// extracted by mini-css-extract-plugin
export default {"cls1":"TxdBfPgzeTtAxQ2oBVVn","cls2":"vbMHFVESaeoieLE7tmNW TxdBfPgzeTtAxQ2oBVVn"};